<template>
  <div @click="onClick">
       
       <div class="inline field">
        <label>Guid: </label>
        <span>{{rowData.guid}}</span>
      </div>
      <div class="inline field">
        <label>Receive Port: </label>
        <span>{{rowData.receive_port}}</span>
      </div>
      <div class="inline field">
        <label>Receive File : </label>
        <span>{{rowData.received_file}}</span>
      </div>
       <div class="inline field">
        <label>Send Port: </label>
        <span>{{rowData.send_port}}</span>
      </div>
     
      
     
</div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
            console.log('DocumentDeleteDetails: on-click', event.target)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/integration-errors/errorDetails.vue